import { render } from "./SettingsIcon.vue?vue&type=template&id=48cb5bb0"
const script = {}

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__